export default __webpack_public_path__ + "static/media/meta_token.3b981936.png";